export const PERMS = {
    READ: 'customer_contacts.read',
    UPDATE: 'customer_contacts.update',
    DELETE: 'customer_contacts.delete',
    CREATE: 'customer_contacts.create',
}
